import { isLoggedInAtom } from 'app/atoms';
import { Column } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useNavigation } from 'app/hooks/navigation';
import { useAuthorize } from 'app/hooks/use-authorize';
import { useUnreadNotificationsCount } from 'app/network/notification';
import { createTheme as createDSTheme } from 'app/shopify';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useUISize } from 'app/utils/web-helpers';
import { IconBell } from '@tabler/icons-react-native';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import type { ColorValue } from 'react-native';
import { Pressable } from 'react-native';

const theme = createDSTheme();

function NotificationsButton({ color = theme.colors['white-label.header.on-header'] }: { color?: ColorValue }) {
  const isLoggedIn = useAtomValue(isLoggedInAtom);
  const navigation = useNavigation();
  const { t } = useTranslation('notifications');
  const { isSmallUI, isLargeUI } = useUISize();
  const { data } = useUnreadNotificationsCount({ enabled: isLoggedIn });
  const withAuthorize = useAuthorize();

  const onPress = () => {
    withAuthorize(() => navigation.navigate('notificationsOverlay', undefined, { pop: true }));
  };

  const minWidth = (data?.unread_count ?? 0) > 9 ? 25 : 22;

  return (
    <Pressable
      accessibilityLabel={t('tabBarLabel')}
      onPress={onPress}
      testID="notifications-header-button"
      style={{
        paddingLeft: 0,
        paddingVertical: isSmallUI ? 13 : 12,
        paddingRight: isSmallUI ? 16 : 0,
        marginRight: isSmallUI ? 4 : 0,
        ...(isLargeUI ? { alignItems: 'center', justifyContent: 'center' } : {}),
      }}
    >
      <IconBell color={color} size={24} strokeWidth={ICON_STROKE_WIDTH} />

      {data?.unread_count ? (
        <Column
          backgroundColor="icon.error"
          borderRadius="radius.sm"
          height={18}
          justifyContent="center"
          minWidth={minWidth}
          position="absolute"
          right={6}
          top={8}
        >
          <Text fontSize={12} fontWeight="600" style={{ textAlign: 'center', color: 'white' }}>
            {Math.min(data.unread_count, 99)}
          </Text>
        </Column>
      ) : null}
    </Pressable>
  );
}

export { NotificationsButton };
